export enum CARRIER_URL_PLACEHOLDERS {
  ParcelToPostCodeCustomer = '{{parcel_to_postcode_customer}}',
  ParcelId = '{{Parcel.ID}}',
}

export const MOCK_CARRIER_REFERENCE_KEY = 'pmtcar';
